import React from 'react';
import EDSimpleCheckbox from '../../../../BaseComponents/Checkboxes/SimpleCheckbox/EDSimpleCheckbox';
import EDIcon from '../../../../BaseComponents/Icon/EDIcon';
import EDListItemText from '../../../../BaseComponents/List/Components/EDListItemText';

import { makeStyles } from 'tss-react/mui';

interface IProps {
  text: React.ReactNode;
  disabled?: boolean;
  checked: boolean;
  indeterminate?: boolean;
  indeterminateColored?: boolean;
  position?: number;
  expandable?: boolean;
  open?: boolean;
  classes?: any;
}

const useStyles = makeStyles<IProps>()(
  (theme, props) =>
    ({
      itemContainer: {
        display: 'flex',
        width: 'calc(100% - 16px)',
        padding: '0px 8px',
        alignItems: 'center',
        '&:hover': {
          backgroundColor: theme.palette.grey[300],
        },
      },
      itemContainerDisabled: {
        '&:hover': {
          backgroundColor: 'inherit',
        },
      },
      subdirectory: {
        color: theme.palette.grey[500],
        paddingLeft: props.position ? props.position * 12 : 0,
        paddingRight: 8,
      },
      textMargin: {
        marginRight: 24,
      },
    } as const)
);

const CheckboxSelectListItemView: React.FC<
  React.PropsWithChildren<IProps & React.RefAttributes<HTMLDivElement>>
> = React.forwardRef<HTMLDivElement, IProps>((props, ref) => {
  const { classes, cx } = useStyles(props, {
    props: props as any,
  });
  return (
    <div
      className={cx(classes.itemContainer, {
        [classes.itemContainerDisabled]: props.disabled,
      })}
      ref={ref}
    >
      <EDSimpleCheckbox
        color="secondary"
        disabled={props.disabled}
        checked={props.checked}
        indeterminate={props.indeterminate}
        disableRipple
        small
      />
      {props.position != undefined && props.position > 0 && (
        <EDIcon
          iconType="subdirectory_arrow_right"
          paddingRight={1}
          paddingLeft={props.position ? props.position * 1.5 : 0}
          color="lowEmphasis"
        />
      )}
      <EDListItemText
        primary={props.text}
        classes={{
          root: cx({
            [classes.textMargin]: !props.expandable,
          }),
        }}
        noLineBreak
        bold
        noLeftPadding
      />
      {props.expandable && props.open && <EDIcon iconType="expand_less" />}
      {props.expandable && !props.open && <EDIcon iconType="expand_more" />}
    </div>
  );
});

export default CheckboxSelectListItemView;
